export default "__VITE_ASSET__DiO4AIvl__"